// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.leaves-attendance-container {
  padding: 0px 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 4px; /* Match margin from SelectionLocation_Outer */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.page-description {
  font-size: 13px;
  color: #333;
  /* margin-bottom: 15px;
}

.controls-section {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  align-items: center;
  flex-wrap: wrap; /* Allow controls to wrap on smaller screens */
}

.search-input {
  flex-grow: 1;
  max-width: 350px;
}

/* .filter-select {
  min-width: 200px;
  background-color: white; 
} */
.table-responsive-wrapper {
  overflow-x: auto; /* Enables horizontal scrolling for the table on small screens */
  width: 100%;
}
.attendance-table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  width: 100%;
  /* border-collapse: separate; */
  border-spacing: 0 5px;
  /* margin-top: -22px; */ /* Removed this problematic line */
  border: 1px solid #d9e3d9;
}

.attendance-table td {
    border: 1px solid #e0e0e0;
    padding: 8px 8px;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    margin-top: 4px;
}

.attendance-table th {
  border: 1px solid #e0e0e0;
  padding: 6px 14px;
  text-align: center;
  font-size: 10px;
  margin-top: 4px;
  background-color: #c5cad1;
  color: black;
  font-weight: 600;
  text-transform: uppercase;
 
}


.attendance-table tbody tr:nth-child(even) {
  background-color: #f8f8f8;
}

.attendance-table tbody tr:hover {
  background-color: #e9eff5;
}

.actions-cell {
  text-align: center; /* Center buttons in the actions cell */
  /* display: flex; */
}

.action-button {
     padding: 2px 4px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 10px;
    margin: 0px 4px;
    color: white;
    transition: background-color 0.2s ease;
    background-color: #9da4ab;
}
.action-button:hover{
   background-color: #6d6e6fcf;
   
}


.no-data-cell {
  text-align: center;
  padding: 20px;
  color: #777;
  font-style: italic;
}
.table-container__attendance {
  border: 1px solid rgb(122, 122, 122);
  border-radius: 8px;

  overflow: scroll;
  height: 228px;
}
.controls-section {
  display: flex;
  /* gap: 327px; */
}
.controls-section input {
  /* width: 20%; */
  max-width: 18vw;
  border: 1px solid #c4c3c3;
  height: 24px;
  border-radius: 6px;
  margin: 6px;
  padding: 8px;
}
.controls-section select {
  width: 28%;
  border: 1px solid #c4c3c3;
  height: 24px;
  border-radius: 6px;
  padding: 1px;
  margin-top: 6px;
}
.controls-section select option{
  padding: 0px;
}
/* Responsive Adjustments */

/* Tablet - 768px */
@media (max-width: 1024px) {
  .controls-section {
    flex-direction: column;
    align-items: stretch;
  }

  /* .search-input,
  .filter-select {
    width: 100%;
    max-width: none;
    margin-bottom: 10px;
  } */

  /* .filter-select {
    padding: 8px;
    margin-top: 4px;
    border: 1px solid #ccc;
    border-radius: 4px;
  } */

  .attendance-table th,
  .attendance-table td {
    padding: 8px 10px;
    font-size: 13px;
  }

  .action-button {
    padding: 5px 10px;
    font-size: 12px;
  }
}

/* Mobile - up to 767px */
@media (max-width: 767px) {
  .leaves-attendance-container {
    padding: 10px;
    margin: 5px;
  }

  .page-description {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

@media (min-width: 1440px) {
  .leaves-attendance-container {
    /* Example: Increase padding for larger screens if desired */
    /* padding: 25px; */
  }
  .search-input {
    max-width: 450px; /* Allow search input to be a bit wider */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/PayRole/Pay_LeavesAttendance/Pay_LeavesAttendance.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW,EAAE,8CAA8C;EAC3D,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,WAAW;EACX;;;;;;;;iEAQ+D;AACjE;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;GAGG;AACH;EACE,gBAAgB,EAAE,gEAAgE;EAClF,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB,EAAE,kCAAkC;EAC3D,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;;AAE3B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB,EAAE,uCAAuC;EAC3D,mBAAmB;AACrB;;AAEA;KACK,gBAAgB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,yBAAyB;AAC7B;AACA;GACG,2BAA2B;;AAE9B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kBAAkB;;EAElB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA,2BAA2B;;AAE3B,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;;KAKG;;EAEH;;;;;KAKG;;EAEH;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4DAA4D;IAC5D,mBAAmB;EACrB;EACA;IACE,gBAAgB,EAAE,yCAAyC;EAC7D;AACF","sourcesContent":["\n.leaves-attendance-container {\n  padding: 0px 15px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  margin: 4px; /* Match margin from SelectionLocation_Outer */\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.page-description {\n  font-size: 13px;\n  color: #333;\n  /* margin-bottom: 15px;\n}\n\n.controls-section {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 25px;\n  align-items: center;\n  flex-wrap: wrap; /* Allow controls to wrap on smaller screens */\n}\n\n.search-input {\n  flex-grow: 1;\n  max-width: 350px;\n}\n\n/* .filter-select {\n  min-width: 200px;\n  background-color: white; \n} */\n.table-responsive-wrapper {\n  overflow-x: auto; /* Enables horizontal scrolling for the table on small screens */\n  width: 100%;\n}\n.attendance-table {\n  width: 100%;\n  border-collapse: collapse;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  width: 100%;\n  /* border-collapse: separate; */\n  border-spacing: 0 5px;\n  /* margin-top: -22px; */ /* Removed this problematic line */\n  border: 1px solid #d9e3d9;\n}\n\n.attendance-table td {\n    border: 1px solid #e0e0e0;\n    padding: 8px 8px;\n    text-align: center;\n    font-size: 10px;\n    font-weight: 400;\n    margin-top: 4px;\n}\n\n.attendance-table th {\n  border: 1px solid #e0e0e0;\n  padding: 6px 14px;\n  text-align: center;\n  font-size: 10px;\n  margin-top: 4px;\n  background-color: #c5cad1;\n  color: black;\n  font-weight: 600;\n  text-transform: uppercase;\n \n}\n\n\n.attendance-table tbody tr:nth-child(even) {\n  background-color: #f8f8f8;\n}\n\n.attendance-table tbody tr:hover {\n  background-color: #e9eff5;\n}\n\n.actions-cell {\n  text-align: center; /* Center buttons in the actions cell */\n  /* display: flex; */\n}\n\n.action-button {\n     padding: 2px 4px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 10px;\n    margin: 0px 4px;\n    color: white;\n    transition: background-color 0.2s ease;\n    background-color: #9da4ab;\n}\n.action-button:hover{\n   background-color: #6d6e6fcf;\n   \n}\n\n\n.no-data-cell {\n  text-align: center;\n  padding: 20px;\n  color: #777;\n  font-style: italic;\n}\n.table-container__attendance {\n  border: 1px solid rgb(122, 122, 122);\n  border-radius: 8px;\n\n  overflow: scroll;\n  height: 228px;\n}\n.controls-section {\n  display: flex;\n  /* gap: 327px; */\n}\n.controls-section input {\n  /* width: 20%; */\n  max-width: 18vw;\n  border: 1px solid #c4c3c3;\n  height: 24px;\n  border-radius: 6px;\n  margin: 6px;\n  padding: 8px;\n}\n.controls-section select {\n  width: 28%;\n  border: 1px solid #c4c3c3;\n  height: 24px;\n  border-radius: 6px;\n  padding: 1px;\n  margin-top: 6px;\n}\n.controls-section select option{\n  padding: 0px;\n}\n/* Responsive Adjustments */\n\n/* Tablet - 768px */\n@media (max-width: 1024px) {\n  .controls-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  /* .search-input,\n  .filter-select {\n    width: 100%;\n    max-width: none;\n    margin-bottom: 10px;\n  } */\n\n  /* .filter-select {\n    padding: 8px;\n    margin-top: 4px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  } */\n\n  .attendance-table th,\n  .attendance-table td {\n    padding: 8px 10px;\n    font-size: 13px;\n  }\n\n  .action-button {\n    padding: 5px 10px;\n    font-size: 12px;\n  }\n}\n\n/* Mobile - up to 767px */\n@media (max-width: 767px) {\n  .leaves-attendance-container {\n    padding: 10px;\n    margin: 5px;\n  }\n\n  .page-description {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n}\n\n@media (min-width: 1440px) {\n  .leaves-attendance-container {\n    /* Example: Increase padding for larger screens if desired */\n    /* padding: 25px; */\n  }\n  .search-input {\n    max-width: 450px; /* Allow search input to be a bit wider */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
